import gql from 'graphql-tag';

const eligibilityProductsQuery = gql`
  query externalProducts {
    externalProducts {
      categoryCode
      displayName
      active
    }
  }
`;

export default eligibilityProductsQuery;
